import React, { useState, useEffect } from 'react';
import { ReactComponent as Logo } from './assets/word_nalegke.svg';
import {
  Box,
  Chip,
  Container,
  Typography,
  Button,
  Grid,
  Card,
  CardContent,
  TextField,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  IconButton,
  Dialog,
  useMediaQuery,
  useTheme,
  Alert,
  Snackbar,
  Paper,
  Divider,
  Fade,
  Zoom,
  Stack,
  List,
  ListItem,
  ListItemIcon,
  ListItemText
} from '@mui/material';
import {
  ExpandMore as ExpandMoreIcon,
  Business as BusinessIcon,
  LocalShipping as DeliveryIcon,
  Person as PersonIcon,
  TrendingUp as GrowthIcon,
  AttachMoney as MoneyIcon,
  Security as SecurityIcon,
  Speed as SpeedIcon,
  Language as GlobalIcon,
  PlayArrow as PlayIcon,
  Email as EmailIcon,
  Phone as PhoneIcon,
  LinkedIn as LinkedInIcon,
  Close as CloseIcon,
  CheckCircle as CheckIcon,
  Stars as StarsIcon,
  Rocket as RocketIcon,
  LocationOn as LocationIcon,
  Schedule as ScheduleIcon,
  Verified as VerifiedIcon
} from '@mui/icons-material';

// Replace with your actual Rutube video URL or embed code
const RUTUBE_VIDEO_URL = 'https://rutube.ru/video/private/1276e40563f2751919bc160f5668b4fe/?p=x0bCFtVqU9FxhlcmBjVaBw';

function LandingPage() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isTablet = useMediaQuery(theme.breakpoints.down('lg'));
  
  const [videoDialogOpen, setVideoDialogOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [contactForm, setContactForm] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    message: ''
  });
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success'
  });

  // Handle scroll effect
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleContactSubmit = (e) => {
    e.preventDefault();
    console.log('Contact form submitted:', contactForm);
    setSnackbar({
      open: true,
      message: 'Спасибо! Мы свяжемся с вами в ближайшее время.',
      severity: 'success'
    });
    setContactForm({
      name: '',
      email: '',
      phone: '',
      company: '',
      message: ''
    });
  };

  const handleInputChange = (e) => {
    setContactForm({
      ...contactForm,
      [e.target.name]: e.target.value
    });
  };

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#fafafa' }}>
      {/* Floating Navigation Bar */}
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          zIndex: 1100,
          bgcolor: scrolled ? 'rgba(255,255,255,0.95)' : 'transparent',
          backdropFilter: scrolled ? 'blur(10px)' : 'none',
          boxShadow: scrolled ? '0 2px 20px rgba(0,0,0,0.1)' : 'none',
          transition: 'all 0.3s ease',
          py: 2
        }}
      >
        <Container maxWidth="lg">
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Logo
  style={{
    height: 45,
    cursor: 'pointer'
  }}
  onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
/>
            {!isMobile && (
              <Stack direction="row" spacing={3}>
                <Button color="inherit" onClick={() => scrollToSection('market')}>
                  Рынок
                </Button>
                <Button color="inherit" onClick={() => scrollToSection('business')}>
                  Бизнес-модель
                </Button>
                <Button color="inherit" onClick={() => scrollToSection('technology')}>
                  Технологии
                </Button>
                <Button color="inherit" onClick={() => scrollToSection('investment')}>
                  Инвестиции
                </Button>
                <Button 
                  variant="contained" 
                  onClick={() => scrollToSection('contact')}
                  sx={{
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    color: 'white',
                    '&:hover': {
                      background: 'linear-gradient(135deg, #5568d3 0%, #6a3d8f 100%)',
                    }
                  }}
                >
                  Связаться
                </Button>
              </Stack>
            )}
          </Box>
        </Container>
      </Box>

      {/* Hero Section with Video */}
      <Box
        sx={{
          minHeight: '100vh',
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white',
          position: 'relative',
          overflow: 'hidden',
          display: 'flex',
          alignItems: 'center',
          pt: { xs: 10, md: 12 },
          pb: { xs: 8, md: 10 }
        }}
      >
        {/* Animated Background Elements */}
        <Box
          sx={{
            position: 'absolute',
            width: '100%',
            height: '100%',
            overflow: 'hidden',
            opacity: 0.1
          }}
        >
          {[...Array(20)].map((_, i) => (
            <Box
              key={i}
              sx={{
                position: 'absolute',
                width: Math.random() * 300 + 100,
                height: Math.random() * 300 + 100,
                borderRadius: '50%',
                background: 'white',
                top: `${Math.random() * 100}%`,
                left: `${Math.random() * 100}%`,
                animation: `float ${Math.random() * 10 + 10}s infinite ease-in-out`,
                '@keyframes float': {
                  '0%, 100%': {
                    transform: 'translate(0, 0)'
                  },
                  '50%': {
                    transform: `translate(${Math.random() * 100 - 50}px, ${Math.random() * 100 - 50}px)`
                  }
                }
              }}
            />
          ))}
        </Box>

        <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 1 }}>
          <Grid container spacing={6} alignItems="center">
            <Grid item xs={12} lg={6}>
              <Fade in timeout={1000}>
                <Box>
                  <Zoom in timeout={1200}>
                    <Box sx={{ display: 'inline-block', mb: 3 }}>
                      <Chip
                        icon={<RocketIcon />}
                        label="Инвестиционная возможность"
                        sx={{
                          bgcolor: 'rgba(255,255,255,0.2)',
                          color: 'white',
                          fontWeight: 600,
                          px: 2,
                          py: 2.5,
                          '& .MuiChip-icon': {
                            color: 'white'
                          }
                        }}
                      />
                    </Box>
                  </Zoom>
                  <Typography 
                    variant="h1" 
                    component="h1" 
                    gutterBottom
                    sx={{ 
                      fontWeight: 800,
                      fontSize: { xs: '2.5rem', sm: '3.5rem', md: '4.5rem' },
                      lineHeight: 1.1,
                      mb: 3,
                      textShadow: '2px 2px 4px rgba(0,0,0,0.2)'
                    }}
                  >
                    Налегке
                  </Typography>
                  <Typography 
                    variant="h4" 
                    sx={{ 
                      mb: 3,
                      opacity: 0.95,
                      fontSize: { xs: '1.3rem', sm: '1.6rem', md: '2rem' },
                      fontWeight: 500,
                      lineHeight: 1.4
                    }}
                  >
                    Первая российская платформа для хранения и доставки багажа
                  </Typography>
                  <Typography 
                    variant="h6" 
                    sx={{ 
                      mb: 5,
                      fontSize: { xs: '1rem', md: '1.2rem' },
                      lineHeight: 1.8,
                      opacity: 0.9,
                      maxWidth: 600
                    }}
                  >
                    Трёхсторонняя маркетплейс-модель, объединяющая путешественников, 
                    партнёров по хранению и курьеров. Рынок $1.2 млрд с ростом 15% в год.
                  </Typography>
                  <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} sx={{ mb: 4 }}>
                    <Button
                      variant="contained"
                      size="large"
                      onClick={() => setVideoDialogOpen(true)}
                      startIcon={<PlayIcon />}
                      sx={{
                        bgcolor: 'white',
                        color: '#667eea',
                        fontSize: '1.1rem',
                        py: 2,
                        px: 4,
                        '&:hover': {
                          bgcolor: 'rgba(255,255,255,0.9)',
                          transform: 'translateY(-2px)',
                          boxShadow: '0 10px 30px rgba(0,0,0,0.3)'
                        },
                        transition: 'all 0.3s ease'
                      }}
                    >
                      Смотреть демо
                    </Button>
                    <Button
                      variant="outlined"
                      size="large"
                      onClick={() => scrollToSection('contact')}
                      sx={{
                        borderColor: 'white',
                        borderWidth: 2,
                        color: 'white',
                        fontSize: '1.1rem',
                        py: 2,
                        px: 4,
                        '&:hover': {
                          borderColor: 'white',
                          borderWidth: 2,
                          bgcolor: 'rgba(255,255,255,0.15)',
                          transform: 'translateY(-2px)'
                        },
                        transition: 'all 0.3s ease'
                      }}
                    >
                      Связаться с нами
                    </Button>
                  </Stack>
                  <Stack direction="row" spacing={4} sx={{ mt: 4 }}>
                    <Box>
                      <Typography variant="h4" sx={{ fontWeight: 700, mb: 0.5 }}>
                        500M+
                      </Typography>
                      <Typography variant="body2" sx={{ opacity: 0.9 }}>
                        Путешественников
                      </Typography>
                    </Box>
                    <Box>
                      <Typography variant="h4" sx={{ fontWeight: 700, mb: 0.5 }}>
                        ₽800
                      </Typography>
                      <Typography variant="body2" sx={{ opacity: 0.9 }}>
                        Средний чек
                      </Typography>
                    </Box>
                    <Box>
                      <Typography variant="h4" sx={{ fontWeight: 700, mb: 0.5 }}>
                        15%
                      </Typography>
                      <Typography variant="body2" sx={{ opacity: 0.9 }}>
                        Годовой рост
                      </Typography>
                    </Box>
                  </Stack>
                </Box>
              </Fade>
            </Grid>

            <Grid item xs={12} lg={6}>
              <Zoom in timeout={1500}>
                <Box
                  sx={{
                    position: 'relative',
                    cursor: 'pointer',
                    '&:hover': {
                      '& .play-overlay': {
                        transform: 'scale(1.1)',
                        bgcolor: 'rgba(255,255,255,0.95)'
                      }
                    }
                  }}
                  onClick={() => setVideoDialogOpen(true)}
                >
                  <Paper
                    elevation={20}
                    sx={{
                      position: 'relative',
                      paddingTop: '56.25%',
                      bgcolor: 'rgba(0,0,0,0.4)',
                      borderRadius: 4,
                      overflow: 'hidden',
                      border: '4px solid rgba(255,255,255,0.3)'
                    }}
                  >
                    <Box
                      className="play-overlay"
                      sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: 100,
                        height: 100,
                        borderRadius: '50%',
                        bgcolor: 'white',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        boxShadow: '0 10px 40px rgba(0,0,0,0.3)',
                        transition: 'all 0.3s ease'
                      }}
                    >
                      <PlayIcon sx={{ fontSize: 50, color: '#667eea', ml: 1 }} />
                    </Box>
                  </Paper>
                  <Typography 
                    variant="body2" 
                    align="center" 
                    sx={{ mt: 2, opacity: 0.9, fontSize: '1.1rem' }}
                  >
                    Смотрите полное демо продукта
                  </Typography>
                </Box>
              </Zoom>
            </Grid>
          </Grid>
        </Container>
      </Box>

      {/* Market Opportunity Section */}
      <Box id="market" sx={{ py: { xs: 8, md: 12 }, bgcolor: 'white' }}>
        <Container maxWidth="lg">
          <Box sx={{ textAlign: 'center', mb: 8 }}>
            <Typography 
              variant="overline" 
              sx={{ 
                color: 'primary.main', 
                fontWeight: 700,
                fontSize: '1rem',
                letterSpacing: 2
              }}
            >
              РЫНОЧНАЯ ВОЗМОЖНОСТЬ
            </Typography>
            <Typography 
              variant="h2" 
              gutterBottom
              sx={{ 
                fontWeight: 700,
                fontSize: { xs: '2rem', md: '3rem' },
                mt: 2,
                mb: 3
              }}
            >
              Быстрорастущий рынок
            </Typography>
            <Typography 
              variant="h5" 
              color="text.secondary"
              sx={{ maxWidth: 800, mx: 'auto', lineHeight: 1.6 }}
            >
              Глобальный рынок хранения багажа оценивается в $1.2 млрд 
              и растёт на 15% ежегодно
            </Typography>
          </Box>

          <Grid container spacing={4}>
            {[
              {
                icon: <PersonIcon />,
                number: '500M+',
                title: 'Путешественников ежегодно',
                description: 'Потенциальных клиентов в России, нуждающихся в хранении багажа',
                color: '#667eea'
              },
              {
                icon: <MoneyIcon />,
                number: '₽800',
                title: 'Средний чек',
                description: 'На одно бронирование с маржинальностью 65-70%',
                color: '#764ba2'
              },
              {
                icon: <GrowthIcon />,
                number: '15%',
                title: 'Годовой рост рынка',
                description: 'Устойчивый рост с восстановлением туризма после пандемии',
                color: '#f093fb'
              }
            ].map((stat, index) => (
              <Grid item xs={12} md={4} key={index}>
                <Zoom in timeout={1000 + index * 200}>
                  <Card 
                    sx={{ 
                      height: '100%',
                      transition: 'all 0.3s ease',
                      '&:hover': {
                        transform: 'translateY(-12px)',
                        boxShadow: '0 20px 40px rgba(0,0,0,0.15)'
                      },
                      border: `2px solid ${stat.color}20`,
                      background: `linear-gradient(135deg, ${stat.color}05 0%, white 100%)`
                    }}
                  >
                    <CardContent sx={{ p: 4, textAlign: 'center' }}>
                      <Box
                        sx={{
                          width: 90,
                          height: 90,
                          borderRadius: '50%',
                          background: `linear-gradient(135deg, ${stat.color} 0%, ${stat.color}cc 100%)`,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          mx: 'auto',
                          mb: 3,
                          boxShadow: `0 10px 30px ${stat.color}40`
                        }}
                      >
                        {React.cloneElement(stat.icon, { 
                          sx: { fontSize: 45, color: 'white' } 
                        })}
                      </Box>
                      <Typography 
                        variant="h3" 
                        gutterBottom 
                        sx={{ 
                          fontWeight: 800,
                          background: `linear-gradient(135deg, ${stat.color} 0%, ${stat.color}cc 100%)`,
                          backgroundClip: 'text',
                          WebkitBackgroundClip: 'text',
                          WebkitTextFillColor: 'transparent'
                        }}
                      >
                        {stat.number}
                      </Typography>
                      <Typography 
                        variant="h6" 
                        gutterBottom 
                        sx={{ fontWeight: 600, mb: 2 }}
                      >
                        {stat.title}
                      </Typography>
                      <Typography 
                        color="text.secondary" 
                        sx={{ lineHeight: 1.7, fontSize: '1rem' }}
                      >
                        {stat.description}
                      </Typography>
                    </CardContent>
                  </Card>
                </Zoom>
              </Grid>
            ))}
          </Grid>

          <Box sx={{ mt: 8, textAlign: 'center' }}>
            <Paper 
              sx={{ 
                p: 4, 
                background: 'linear-gradient(135deg, #667eea15 0%, #764ba215 100%)',
                border: '2px solid #667eea30'
              }}
            >
              <Typography variant="h5" gutterBottom sx={{ fontWeight: 600 }}>
                🚀 Почему сейчас идеальное время?
              </Typography>
              <Grid container spacing={3} sx={{ mt: 2 }}>
                {[
                  'Восстановление туризма после пандемии',
                  'Рост внутреннего туризма в России',
                  'Цифровизация традиционных услуг',
                  'Отсутствие прямых конкурентов'
                ].map((reason, i) => (
                  <Grid item xs={12} sm={6} md={3} key={i}>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <CheckIcon sx={{ color: 'success.main', mr: 1 }} />
                      <Typography variant="body1">{reason}</Typography>
                    </Box>
                  </Grid>
                ))}
              </Grid>
            </Paper>
          </Box>
        </Container>
      </Box>

      {/* Business Model Section */}
      <Box id="business" sx={{ py: { xs: 8, md: 12 }, bgcolor: '#f8f9fa' }}>
        <Container maxWidth="lg">
          <Box sx={{ textAlign: 'center', mb: 8 }}>
            <Typography 
              variant="overline" 
              sx={{ 
                color: 'primary.main', 
                fontWeight: 700,
                fontSize: '1rem',
                letterSpacing: 2
              }}
            >
              БИЗНЕС-МОДЕЛЬ
            </Typography>
            <Typography 
              variant="h2" 
              gutterBottom
              sx={{ 
                fontWeight: 700,
                fontSize: { xs: '2rem', md: '3rem' },
                mt: 2,
                mb: 3
              }}
            >
              Множественные потоки доходов
            </Typography>
            <Typography 
              variant="h5" 
              color="text.secondary"
              sx={{ maxWidth: 800, mx: 'auto', lineHeight: 1.6 }}
            >
              Трёхсторонняя маркетплейс-платформа с высокой маржинальностью
            </Typography>
          </Box>

          <Grid container spacing={4} sx={{ mb: 6 }}>
            <Grid item xs={12} md={6}>
              <Card 
                sx={{ 
                  height: '100%',
                  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                  color: 'white'
                }}
              >
                <CardContent sx={{ p: 4 }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                    <MoneyIcon sx={{ fontSize: 50, mr: 2 }} />
                    <Typography variant="h4" sx={{ fontWeight: 700 }}>
                      Потоки доходов
                    </Typography>
                  </Box>
                  <Divider sx={{ borderColor: 'rgba(255,255,255,0.3)', mb: 3 }} />
                  <List>
                    {[
                      {
                        title: 'Комиссия с бронирований',
                        detail: '20% от каждой транзакции',
                        amount: '~₽160/заказ'
                      },
                      {
                        title: 'Плата за доставку',
                        detail: '20% от доходов курьеров',
                        amount: '~₽30/доставка'
                      },
                      {
                        title: 'Премиум-партнёрства',
                        detail: 'Подписка ₽5,000-15,000/мес',
                        amount: 'от ₽60,000/год'
                      },
                      {
                        title: 'Дополнительные услуги',
                        detail: 'Страхование, упаковка',
                        amount: '+₽50-200/заказ'
                      }
                    ].map((revenue, i) => (
                      <ListItem key={i} sx={{ px: 0, py: 1.5 }}>
                        <ListItemIcon sx={{ minWidth: 40 }}>
                          <CheckIcon sx={{ color: 'white' }} />
                        </ListItemIcon>
                        <ListItemText
                          primary={
                            <Typography variant="h6" sx={{ fontWeight: 600, mb: 0.5 }}>
                              {revenue.title}
                            </Typography>
                          }
                          secondary={
                            <Box>
                              <Typography sx={{ color: 'rgba(255,255,255,0.9)', mb: 0.5 }}>
                                {revenue.detail}
                              </Typography>
                              <Typography 
                                sx={{ 
                                  color: 'white', 
                                  fontWeight: 700,
                                  fontSize: '1.1rem'
                                }}
                              >
                                {revenue.amount}
                              </Typography>
                            </Box>
                          }
                        />
                      </ListItem>
                    ))}
                  </List>
                </CardContent>
              </Card>
            </Grid>

            <Grid item xs={12} md={6}>
              <Card sx={{ height: '100%', bgcolor: 'white' }}>
                <CardContent sx={{ p: 4 }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                    <SecurityIcon sx={{ fontSize: 50, color: 'success.main', mr: 2 }} />
                    <Typography variant="h4" sx={{ fontWeight: 700 }}>
                      Конкурентные преимущества
                    </Typography>
                  </Box>
                  <Divider sx={{ mb: 3 }} />
                  <List>
                    {[
                      {
                        icon: <StarsIcon />,
                        title: 'Первопроходцы на рынке',
                        description: 'Первая полнофункциональная платформа в России'
                      },
                      {
                        icon: <GlobalIcon />,
                        title: 'Сетевые эффекты',
                        description: 'Ценность растёт с каждым новым пользователем'
                      },
                      {
                        icon: <SpeedIcon />,
                        title: 'Низкие операционные расходы',
                        description: 'Asset-light модель с масштабируемой технологией'
                      },
                      {
                        icon: <DeliveryIcon />,
                        title: 'Интегрированная логистика',
                        description: 'Уникальная система доставки между локациями'
                      }
                    ].map((advantage, i) => (
                      <ListItem key={i} sx={{ px: 0, py: 2, alignItems: 'flex-start' }}>
                        <ListItemIcon sx={{ minWidth: 50, mt: 0.5 }}>
                          <Box
                            sx={{
                              width: 40,
                              height: 40,
                              borderRadius: 2,
                              bgcolor: 'success.light',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center'
                            }}
                          >
                            {React.cloneElement(advantage.icon, { 
                              sx: { color: 'success.main', fontSize: 24 } 
                            })}
                          </Box>
                        </ListItemIcon>
                        <ListItemText
                          primary={
                            <Typography variant="h6" sx={{ fontWeight: 600, mb: 0.5 }}>
                              {advantage.title}
                            </Typography>
                          }
                          secondary={
                            <Typography color="text.secondary" sx={{ fontSize: '1rem' }}>
                              {advantage.description}
                            </Typography>
                          }
                        />
                      </ListItem>
                    ))}
                  </List>
                </CardContent>
              </Card>
            </Grid>
          </Grid>

          {/* Unit Economics */}
          <Paper sx={{ p: 4, bgcolor: 'white' }}>
            <Typography variant="h4" gutterBottom sx={{ fontWeight: 700, mb: 4, textAlign: 'center' }}>
              💰 Unit Economics
            </Typography>
            <Grid container spacing={4}>
              <Grid item xs={12} md={6}>
                <Box>
                  <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
                    Средний заказ:
                  </Typography>
                  <Box sx={{ pl: 2 }}>
                    <Typography variant="body1" sx={{ mb: 1 }}>
                      Стоимость хранения: <strong>₽600</strong>
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 1 }}>
                      Доставка (если нужна): <strong>₽200</strong>
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 1 }}>
                      Среднее время хранения: <strong>2-3 дня</strong>
                    </Typography>
                    <Divider sx={{ my: 2 }} />
                    <Typography variant="h6" color="primary">
                      Средний чек: <strong>₽800</strong>
                    </Typography>
                  </Box>
                </Box>
              </Grid>
              <Grid item xs={12} md={6}>
                <Box>
                  <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
                    Наша маржа:
                  </Typography>
                  <Box sx={{ pl: 2 }}>
                    <Typography variant="body1" sx={{ mb: 1 }}>
                      Комиссия с хранения (20%): <strong>₽120</strong>
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 1 }}>
                      Комиссия с доставки (20%): <strong>₽40</strong>
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 1 }}>
                      Операционные расходы: <strong>₽10-15</strong>
                    </Typography>
                    <Divider sx={{ my: 2 }} />
                    <Typography variant="h6" color="success.main">
                      Чистая прибыль: <strong>₽145-150 (18-19%)</strong>
                    </Typography>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Paper>
        </Container>
      </Box>

      {/* Technology Section */}
      <Box id="technology" sx={{ py: { xs: 8, md: 12 }, bgcolor: 'white' }}>
        <Container maxWidth="lg">
          <Box sx={{ textAlign: 'center', mb: 8 }}>
            <Typography 
              variant="overline" 
              sx={{ 
                color: 'primary.main', 
                fontWeight: 700,
                fontSize: '1rem',
                letterSpacing: 2
              }}
            >
              ТЕХНОЛОГИЯ
            </Typography>
            <Typography 
              variant="h2" 
              gutterBottom
              sx={{ 
                fontWeight: 700,
                fontSize: { xs: '2rem', md: '3rem' },
                mt: 2,
                mb: 3
              }}
            >
              Современный технологический стек
            </Typography>
            <Typography 
              variant="h5" 
              color="text.secondary"
              sx={{ maxWidth: 800, mx: 'auto', lineHeight: 1.6 }}
            >
              Полнофункциональная платформа с акцентом на UX и безопасность
            </Typography>
          </Box>

          <Grid container spacing={3}>
            {[
              {
                icon: <SpeedIcon />,
                title: 'Мгновенное бронирование',
                description: 'Резервируйте хранилище за секунды с подтверждением в реальном времени',
                color: '#667eea'
              },
              {
                icon: <SecurityIcon />,
                title: 'Безопасные платежи',
                description: 'Интеграция Robokassa с полной защитой транзакций',
                color: '#764ba2'
              },
              {
                icon: <DeliveryIcon />,
                title: 'Доставка между локациями',
                description: 'Сдайте багаж в одном месте, заберите в другом',
                color: '#f093fb'
              },
              {
                icon: <VerifiedIcon />,
                title: 'QR-верификация',
                description: 'Защищённая система QR-кодов для отслеживания багажа',
                color: '#4facfe'
              },
              {
                icon: <LocationIcon />,
                title: 'Карты в реальном времени',
                description: 'Интеграция Google Maps для удобного поиска локаций',
                color: '#43e97b'
              },
              {
                icon: <BusinessIcon />,
                title: 'Партнёрская панель',
                description: 'Полнофункциональная система управления для партнёров',
                color: '#fa709a'
              }
            ].map((feature, index) => (
              <Grid item xs={12} sm={6} md={4} key={index}>
                <Zoom in timeout={1000 + index * 100}>
                  <Card 
                    sx={{ 
                      height: '100%',
                      transition: 'all 0.3s ease',
                      '&:hover': {
                        transform: 'translateY(-8px)',
                        boxShadow: `0 15px 35px ${feature.color}30`
                      },
                      border: `1px solid ${feature.color}20`
                    }}
                  >
                    <CardContent sx={{ p: 3 }}>
                      <Box
                        sx={{
                          width: 70,
                          height: 70,
                          borderRadius: 3,
                          background: `linear-gradient(135deg, ${feature.color} 0%, ${feature.color}cc 100%)`,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          mb: 2.5,
                          boxShadow: `0 10px 25px ${feature.color}40`
                        }}
                      >
                        {React.cloneElement(feature.icon, { 
                          sx: { fontSize: 35, color: 'white' } 
                        })}
                      </Box>
                      <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, mb: 1.5 }}>
                        {feature.title}
                      </Typography>
                      <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.7 }}>
                        {feature.description}
                      </Typography>
                    </CardContent>
                  </Card>
                </Zoom>
              </Grid>
            ))}
          </Grid>

          <Box sx={{ mt: 6 }}>
            <Paper sx={{ p: 4, bgcolor: '#f8f9fa' }}>
              <Grid container spacing={3} alignItems="center">
                <Grid item xs={12} md={6}>
                  <Typography variant="h5" gutterBottom sx={{ fontWeight: 600 }}>
                    🔧 Технический стек:
                  </Typography>
                  <List>
                    {[
                      'React + Material-UI для фронтенда',
                      'Firebase для бэкенда и БД',
                      'Google Maps API для геолокации',
                      'Robokassa для платежей',
                      'QR-коды для верификации'
                    ].map((tech, i) => (
                      <ListItem key={i} sx={{ px: 0 }}>
                        <ListItemIcon sx={{ minWidth: 35 }}>
                          <CheckIcon color="success" />
                        </ListItemIcon>
                        <ListItemText primary={tech} />
                      </ListItem>
                    ))}
                  </List>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Typography variant="h5" gutterBottom sx={{ fontWeight: 600 }}>
                    ✅ Готовые функции:
                  </Typography>
                  <List>
                    {[
                      'Полная система бронирования',
                      'Панели для 3 типов пользователей',
                      'Платёжная интеграция',
                      'Система отслеживания багажа',
                      'Мобильная адаптация'
                    ].map((feature, i) => (
                      <ListItem key={i} sx={{ px: 0 }}>
                        <ListItemIcon sx={{ minWidth: 35 }}>
                          <CheckIcon color="primary" />
                        </ListItemIcon>
                        <ListItemText primary={feature} />
                      </ListItem>
                    ))}
                  </List>
                </Grid>
              </Grid>
            </Paper>
          </Box>
        </Container>
      </Box>

      {/* Investment Section */}
      <Box id="investment" sx={{ py: { xs: 8, md: 12 }, bgcolor: '#f8f9fa' }}>
        <Container maxWidth="lg">
          <Box sx={{ textAlign: 'center', mb: 8 }}>
            <Typography 
              variant="overline" 
              sx={{ 
                color: 'primary.main', 
                fontWeight: 700,
                fontSize: '1rem',
                letterSpacing: 2
              }}
            >
              ИНВЕСТИЦИОННАЯ ВОЗМОЖНОСТЬ
            </Typography>
            <Typography 
              variant="h2" 
              gutterBottom
              sx={{ 
                fontWeight: 700,
                fontSize: { xs: '2rem', md: '3rem' },
                mt: 2,
                mb: 3
              }}
            >
              Присоединяйтесь к нам
            </Typography>
            <Typography 
              variant="h5" 
              color="text.secondary"
              sx={{ maxWidth: 800, mx: 'auto', lineHeight: 1.6 }}
            >
              Привлекательная возможность для инвесторов на ранней стадии
            </Typography>
          </Box>

          <Grid container spacing={4} sx={{ mb: 6 }}>
            <Grid item xs={12} md={6}>
              <Card sx={{ height: '100%', bgcolor: 'white' }}>
                <CardContent sx={{ p: 4 }}>
                  <Typography variant="h4" gutterBottom sx={{ fontWeight: 700, mb: 4 }}>
                    ✨ Что мы предлагаем
                  </Typography>
                  <List>
                    {[
                      {
                        title: 'MVP готов',
                        description: 'Полнофункциональная платформа с действующими пользователями'
                      },
                      {
                        title: 'Подтверждённый спрос',
                        description: 'Положительные отзывы ранних пользователей'
                      },
                      {
                        title: 'Масштабируемая технология',
                        description: 'Современный стек готов к быстрому росту'
                      },
                      {
                        title: 'Опытная команда',
                        description: 'Профессионалы из технологического и туристического секторов'
                      },
                      {
                        title: 'Чёткий путь к прибыли',
                        description: 'Множественные потоки доходов с высокой маржой'
                      }
                    ].map((item, i) => (
                      <ListItem key={i} sx={{ px: 0, py: 2, alignItems: 'flex-start' }}>
                        <ListItemIcon sx={{ minWidth: 40, mt: 0.5 }}>
                          <CheckIcon color="success" />
                        </ListItemIcon>
                        <ListItemText
                          primary={
                            <Typography variant="h6" sx={{ fontWeight: 600, mb: 0.5 }}>
                              {item.title}
                            </Typography>
                          }
                          secondary={
                            <Typography color="text.secondary">
                              {item.description}
                            </Typography>
                          }
                        />
                      </ListItem>
                    ))}
                  </List>
                </CardContent>
              </Card>
            </Grid>

            <Grid item xs={12} md={6}>
              <Card sx={{ height: '100%', bgcolor: 'white' }}>
                <CardContent sx={{ p: 4 }}>
                  <Typography variant="h4" gutterBottom sx={{ fontWeight: 700, mb: 4 }}>
                    💼 Использование средств
                  </Typography>
                  {[
                    { label: 'Маркетинг и привлечение', value: '40%', color: '#667eea' },
                    { label: 'Разработка продукта', value: '30%', color: '#764ba2' },
                    { label: 'Операционные расходы', value: '20%', color: '#f093fb' },
                    { label: 'Юридические и лицензии', value: '10%', color: '#4facfe' }
                  ].map((item, index) => (
                    <Box key={index} sx={{ mb: 4 }}>
                      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1.5 }}>
                        <Typography variant="h6" sx={{ fontWeight: 600 }}>
                          {item.label}
                        </Typography>
                        <Typography variant="h6" sx={{ fontWeight: 700, color: item.color }}>
                          {item.value}
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          height: 16,
                          bgcolor: 'grey.200',
                          borderRadius: 2,
                          overflow: 'hidden',
                          boxShadow: 'inset 0 2px 4px rgba(0,0,0,0.1)'
                        }}
                      >
                        <Box
                          sx={{
                            width: item.value,
                            height: '100%',
                            background: `linear-gradient(90deg, ${item.color} 0%, ${item.color}cc 100%)`,
                            transition: 'width 1s ease',
                            boxShadow: `0 0 10px ${item.color}80`
                          }}
                        />
                      </Box>
                    </Box>
                  ))}
                </CardContent>
              </Card>
            </Grid>
          </Grid>

          {/* Roadmap */}
          <Paper sx={{ p: 4, bgcolor: 'white' }}>
            <Typography variant="h4" gutterBottom sx={{ fontWeight: 700, mb: 4, textAlign: 'center' }}>
              🗺️ План масштабирования
            </Typography>
            <Grid container spacing={4}>
              {[
                {
                  phase: 'Фаза 1',
                  period: '0-6 месяцев',
                  title: 'Доминирование в Москве и СПб',
                  goals: [
                    '1,000+ активных локаций',
                    '50,000+ пользователей',
                    '₽5M ежемесячный оборот'
                  ]
                },
                {
                  phase: 'Фаза 2',
                  period: '6-18 месяцев',
                  title: 'Расширение по России',
                  goals: [
                    '10 крупнейших городов',
                    '200,000+ пользователей',
                    '₽25M ежемесячный оборот'
                  ]
                },
                {
                  phase: 'Фаза 3',
                  period: '18-36 месяцев',
                  title: 'Международная экспансия',
                  goals: [
                    'СНГ и Восточная Европа',
                    '1M+ пользователей',
                    '₽100M+ ежемесячный оборот'
                  ]
                }
              ].map((phase, i) => (
                <Grid item xs={12} md={4} key={i}>
                  <Card 
                    sx={{ 
                      height: '100%',
                      border: '2px solid',
                      borderColor: i === 0 ? 'primary.main' : i === 1 ? 'secondary.main' : 'success.main',
                      position: 'relative',
                      overflow: 'visible'
                    }}
                  >
                    <Box
                      sx={{
                        position: 'absolute',
                        top: -15,
                        left: 20,
                        bgcolor: i === 0 ? 'primary.main' : i === 1 ? 'secondary.main' : 'success.main',
                        color: 'white',
                        px: 2,
                        py: 0.5,
                        borderRadius: 2,
                        fontWeight: 700
                      }}
                    >
                      {phase.phase}
                    </Box>
                    <CardContent sx={{ p: 3, pt: 4 }}>
                      <Typography variant="h6" color="text.secondary" gutterBottom>
                        {phase.period}
                      </Typography>
                      <Typography variant="h5" sx={{ fontWeight: 600, mb: 3 }}>
                        {phase.title}
                      </Typography>
                      <List dense>
                        {phase.goals.map((goal, j) => (
                          <ListItem key={j} sx={{ px: 0 }}>
                            <ListItemIcon sx={{ minWidth: 30 }}>
                              <CheckIcon color={i === 0 ? 'primary' : i === 1 ? 'secondary' : 'success'} />
                            </ListItemIcon>
                            <ListItemText primary={goal} />
                          </ListItem>
                        ))}
                      </List>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </Paper>
        </Container>
      </Box>

      {/* FAQ Section */}
      <Box sx={{ py: { xs: 8, md: 12 }, bgcolor: 'white' }}>
        <Container maxWidth="lg">
          <Box sx={{ textAlign: 'center', mb: 8 }}>
            <Typography 
              variant="overline" 
              sx={{ 
                color: 'primary.main', 
                fontWeight: 700,
                fontSize: '1rem',
                letterSpacing: 2
              }}
            >
              FAQ
            </Typography>
            <Typography 
              variant="h2" 
              gutterBottom
              sx={{ 
                fontWeight: 700,
                fontSize: { xs: '2rem', md: '3rem' },
                mt: 2,
                mb: 3
              }}
            >
              Часто задаваемые вопросы
            </Typography>
            <Typography 
              variant="h5" 
              color="text.secondary"
              sx={{ maxWidth: 800, mx: 'auto', lineHeight: 1.6 }}
            >
              Ответы на ключевые вопросы инвесторов
            </Typography>
          </Box>

          <Box sx={{ maxWidth: 900, mx: 'auto' }}>
            {[
              {
                question: 'Каков размер целевого рынка?',
                answer: 'Глобальный рынок хранения багажа оценивается в $1.2 млрд с годовым ростом 15%. Только российский рынок представляет возможность в $150-200 млн, с более чем 500 млн путешественников ежегодно, нуждающихся в решениях для хранения.'
              },
              {
                question: 'Как вы планируете привлекать партнёров?',
                answer: 'Наша стратегия включает прямые продажи существующим предприятиям (отели, хостелы, магазины), цифровой маркетинг для малого бизнеса и партнёрские программы с туристическими ассоциациями. Мы предлагаем привлекательные условия комиссий (80% партнёру) и дополнительный поток доходов без капитальных затрат.'
              },
              {
                question: 'Что отличает вас от конкурентов?',
                answer: 'Налегке — первая платформа в России, предлагающая полную трёхстороннюю маркетплейс-модель с интегрированной доставкой. В отличие от конкурентов, фокусирующихся только на хранении, мы предоставляем комплексное решение, позволяющее пользователям сдавать багаж в одном месте и забирать в другом.'
              },
              {
                question: 'Каковы ваши планы по масштабированию?',
                answer: 'Фаза 1: Доминирование в Москве и Санкт-Петербурге (6 месяцев). Фаза 2: Расширение на 10 крупнейших городов России (12 месяцев). Фаза 3: Международная экспансия в СНГ и Восточную Европу (18-24 месяца). Каждая фаза финансируется доходами предыдущей.'
              },
              {
                question: 'Какова ваша стратегия монетизации?',
                answer: 'Мы генерируем доход через: 20% комиссию с бронирований (₽120-160/заказ), 20% комиссию с доставки (₽30-40/доставка), премиум-подписки для партнёров (₽5,000-15,000/месяц), дополнительные услуги (страхование, упаковка). Целевая валовая маржа 65-70% с чистой прибылью 18-19% на заказ.'
              },
              {
                question: 'Как вы обеспечиваете безопасность и доверие?',
                answer: 'Наша платформа включает систему QR-верификации с уникальными кодами для каждого предмета, проверку и сертификацию всех партнёров, страхование до ₽100,000 на предмет, систему рейтингов и отзывов (5 звезд), безопасные платежи через Robokassa с защитой PCI DSS и круглосуточную поддержку клиентов.'
              },
              {
                question: 'Какой объём инвестиций вы ищете и на каких условиях?',
                answer: 'Мы ищем инвестиции в размере ₽10-15 млн для первого раунда финансирования. Средства будут направлены на маркетинг (40%), развитие продукта (30%), операционные расходы (20%) и юридические вопросы (10%). Мы открыты к обсуждению структуры сделки, которая будет выгодна обеим сторонам.'
              },
              {
                question: 'Каковы прогнозы по финансовым показателям?',
                answer: 'Год 1: ₽60M оборот, 50,000 пользователей, выход в ноль. Год 2: ₽300M оборот, 200,000 пользователей, ₽45M EBITDA. Год 3: ₽1.2B оборот, 1M+ пользователей, ₽240M EBITDA. Эти прогнозы основаны на консервативных предположениях о росте рынка и нашей доле.'
              }
            ].map((faq, index) => (
              <Accordion 
                key={index}
                sx={{ 
                  mb: 2,
                  '&:before': { display: 'none' },
                  boxShadow: 2,
                  '&:hover': {
                    boxShadow: 4
                  },
                  borderRadius: 2,
                  overflow: 'hidden'
                }}
              >
                <AccordionSummary 
                  expandIcon={<ExpandMoreIcon />}
                  sx={{
                    bgcolor: '#f8f9fa',
                    '&:hover': {
                      bgcolor: '#e9ecef'
                    }
                  }}
                >
                  <Typography variant="h6" sx={{ fontWeight: 600, fontSize: '1.1rem' }}>
                    {faq.question}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ p: 3 }}>
                  <Typography color="text.secondary" sx={{ lineHeight: 1.8, fontSize: '1rem' }}>
                    {faq.answer}
                  </Typography>
                </AccordionDetails>
              </Accordion>
            ))}
          </Box>
        </Container>
      </Box>

      {/* Contact Section */}
      <Box 
        id="contact"
        sx={{ 
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          py: { xs: 8, md: 12 },
          position: 'relative',
          overflow: 'hidden'
        }}
      >
        {/* Background decoration */}
        <Box
          sx={{
            position: 'absolute',
            width: '100%',
            height: '100%',
            opacity: 0.05
          }}
        >
          <Box
            sx={{
              position: 'absolute',
              width: 500,
              height: 500,
              borderRadius: '50%',
              bgcolor: 'white',
              top: -200,
              right: -100
            }}
          />
          <Box
            sx={{
              position: 'absolute',
              width: 400,
              height: 400,
              borderRadius: '50%',
              bgcolor: 'white',
              bottom: -150,
              left: -50
            }}
          />
        </Box>

        <Container maxWidth="md" sx={{ position: 'relative', zIndex: 1 }}>
          <Box sx={{ textAlign: 'center', mb: 6 }}>
            <Typography 
              variant="h2" 
              gutterBottom
              sx={{ 
                fontWeight: 700,
                fontSize: { xs: '2rem', md: '3rem' },
                color: 'white',
                mb: 2
              }}
            >
              Готовы обсудить инвестицию?
            </Typography>
            <Typography 
              variant="h5"
              sx={{ color: 'rgba(255,255,255,0.95)', mb: 4 }}
            >
              Свяжитесь с нами для получения полной презентации и финансовой модели
            </Typography>
          </Box>

          <Paper elevation={10} sx={{ borderRadius: 4 }}>
            <CardContent sx={{ p: { xs: 3, md: 5 } }}>
              <Box component="form" onSubmit={handleContactSubmit}>
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      required
                      label="Имя"
                      name="name"
                      value={contactForm.name}
                      onChange={handleInputChange}
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      required
                      label="Компания"
                      name="company"
                      value={contactForm.company}
                      onChange={handleInputChange}
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      required
                      type="email"
                      label="Email"
                      name="email"
                      value={contactForm.email}
                      onChange={handleInputChange}
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="Телефон"
                      name="phone"
                      value={contactForm.phone}
                      onChange={handleInputChange}
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      multiline
                      rows={4}
                      label="Сообщение"
                      name="message"
                      value={contactForm.message}
                      onChange={handleInputChange}
                      variant="outlined"
                      placeholder="Расскажите о вашем интересе к проекту..."
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Button
                      type="submit"
                      variant="contained"
                      size="large"
                      fullWidth
                      sx={{
                        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                        color: 'white',
                        py: 2,
                        fontSize: '1.1rem',
                        fontWeight: 600,
                        '&:hover': {
                          background: 'linear-gradient(135deg, #5568d3 0%, #6a3d8f 100%)',
                          transform: 'translateY(-2px)',
                          boxShadow: '0 10px 30px rgba(0,0,0,0.3)'
                        },
                        transition: 'all 0.3s ease'
                      }}
                    >
                      Отправить запрос
                    </Button>
                  </Grid>
                </Grid>
              </Box>

              <Divider sx={{ my: 4 }} />

              <Box>
                <Typography variant="h6" align="center" gutterBottom sx={{ fontWeight: 600 }}>
                  Или свяжитесь напрямую
                </Typography>
                <Grid container spacing={3} sx={{ mt: 2 }}>
                  <Grid item xs={12} sm={6}>
                    <Box 
                      sx={{ 
                        display: 'flex', 
                        alignItems: 'center', 
                        justifyContent: 'center',
                        p: 2,
                        bgcolor: '#f8f9fa',
                        borderRadius: 2
                      }}
                    >
                      <EmailIcon sx={{ mr: 1.5, color: 'primary.main' }} />
                      <Typography>antongnetov@gmail.com</Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Box 
                      sx={{ 
                        display: 'flex', 
                        alignItems: 'center', 
                        justifyContent: 'center',
                        p: 2,
                        bgcolor: '#f8f9fa',
                        borderRadius: 2
                      }}
                    >
                      <PhoneIcon sx={{ mr: 1.5, color: 'primary.main' }} />
                      <Typography>+7 (XXX) XXX-XX-XX</Typography>
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            </CardContent>
          </Paper>
        </Container>
      </Box>

      {/* Footer */}
      <Box sx={{ bgcolor: '#2c3e50', color: 'white', py: 6 }}>
        <Container>
          <Grid container spacing={4} alignItems="center">
            <Grid item xs={12} md={6}>
              <Logo
  style={{
    height: 45,
    cursor: 'pointer'
  }}
  onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
/>
              <Typography variant="body1" sx={{ opacity: 0.8, mb: 2 }}>
                Первая российская платформа для хранения и доставки багажа
              </Typography>
              <Typography variant="body2" sx={{ opacity: 0.6 }}>
                © 2025 Дорога Налегке. Все права защищены.
              </Typography>
            </Grid>
            <Grid item xs={12} md={6}>
              <Box sx={{ display: 'flex', justifyContent: { xs: 'flex-start', md: 'flex-end' }, gap: 2 }}>
                <IconButton 
                  sx={{ 
                    color: 'white',
                    bgcolor: 'rgba(255,255,255,0.1)',
                    '&:hover': {
                      bgcolor: 'rgba(255,255,255,0.2)'
                    }
                  }}
                >
                  <LinkedInIcon />
                </IconButton>
                <IconButton 
                  sx={{ 
                    color: 'white',
                    bgcolor: 'rgba(255,255,255,0.1)',
                    '&:hover': {
                      bgcolor: 'rgba(255,255,255,0.2)'
                    }
                  }}
                >
                  <EmailIcon />
                </IconButton>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>

      {/* Video Dialog */}
      <Dialog
        open={videoDialogOpen}
        onClose={() => setVideoDialogOpen(false)}
        maxWidth="lg"
        fullWidth
        PaperProps={{
          sx: {
            bgcolor: 'black',
            borderRadius: 3
          }
        }}
      >
        <IconButton
          onClick={() => setVideoDialogOpen(false)}
          sx={{
            position: 'absolute',
            right: 16,
            top: 16,
            color: 'white',
            bgcolor: 'rgba(0,0,0,0.6)',
            '&:hover': {
              bgcolor: 'rgba(0,0,0,0.8)'
            },
            zIndex: 1
          }}
        >
          <CloseIcon />
        </IconButton>
        <Box
  sx={{
    position: 'relative',
    paddingTop: '56.25%', // 16:9
    width: '100%'
  }}
>
  <iframe
    src="https://rutube.ru/play/embed/1276e40563f2751919bc160f5668b4fe?skinColor=8E24AA&autoplay=1"
    title="HopDrop Demo"
    frameBorder="0"
    allow="clipboard-write; autoplay"
    allowFullScreen
    style={{
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      border: 0
    }}
  />
</Box>
      </Dialog>

      {/* Snackbar */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert 
          onClose={() => setSnackbar({ ...snackbar, open: false })} 
          severity={snackbar.severity}
          variant="filled"
          sx={{ width: '100%' }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>

      {/* Scroll to top button */}
      {scrolled && (
        <Zoom in>
          <IconButton
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            sx={{
              position: 'fixed',
              bottom: 32,
              right: 32,
              bgcolor: 'primary.main',
              color: 'white',
              width: 56,
              height: 56,
              boxShadow: 4,
              '&:hover': {
                bgcolor: 'primary.dark',
                transform: 'translateY(-4px)',
                boxShadow: 6
              },
              transition: 'all 0.3s ease',
              zIndex: 1000
            }}
          >
            <ExpandMoreIcon sx={{ transform: 'rotate(180deg)' }} />
          </IconButton>
        </Zoom>
      )}
    </Box>
  );
}



export default LandingPage;
